import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgGoogleIcon from './svgs/GoogleIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var googleIcon = (props => useIcon(SvgGoogleIcon, SvgGoogleIcon, props));

export { googleIcon as default };
